<template>
  <div class="character-container">
    <div class="character">
      <DialogCharacter />
    </div>
  </div>
</template>

<script>
import DialogCharacter from './dialog'

export default {
  components: {
    DialogCharacter
  }
}
</script>

<style lang="scss" scoped>
.character-container {
  @include flexjc;
  flex: 1;
  @include px2res(padding-bottom, 8);
  z-index: 10;

  .character {
    position: relative;
    @include px2res(width, 349);
    @include px2res(height, 715);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/character/index.vue